

// Satellite monitor rule helpers (frontend)
// Keep this file tiny and obvious. Used by pages to avoid repeating role/scope logic.

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null');
  } catch (e) {
    return null;
  }
}

export function isSatelliteMonitor(user = getStoredUser()) {
  return user?.role === 'satellite_monitor';
}

// Normal users/admins are scoped to their studio.
// Satellite monitors see all satellite models across studios.
export function shouldScopeToStudio(user = getStoredUser()) {
  return !isSatelliteMonitor(user);
}

export function modelsApiUrl(user = getStoredUser()) {
  if (!user) return '/api/models';
  return isSatelliteMonitor(user)
    ? '/api/models'
    : `/api/models?studio_id=${user.studio_id}`;
}

export function canCreateModels(user = getStoredUser()) {
  return !isSatelliteMonitor(user) && user?.role !== 'support';
}

export function defaultTabForPage(pageKey, user = getStoredUser()) {
  if (!user) return null;

  // Satellite monitors always start on satellite-focused tabs if the page has tabs.
  if (isSatelliteMonitor(user)) {
    if (pageKey === 'models') return 'satellite';
    // future: if sales/adjustments/reports have tabs, set them here too
  }

  return null; // means "page uses its normal default"
}

